import { MAutocomplete, ResponsiveFormContainer } from "@app/components";
import { MODES_OPTIONS } from "@app/types/generics.types";
import { weeksTable } from "@app/utils/tables/weeks.tables";
import { yearsTable } from "@app/utils/tables/years.tables";
import { Grid, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";

interface DateRangeWeekProps {
  mode: MODES_OPTIONS;
  title?: string;
}

const DateRangeWeek = ({
  mode,
  title = "Por semanas de recogida",
}: DateRangeWeekProps) => {
  const form = useFormContext();
  const isView = mode === MODES_OPTIONS.VIEW;
  const [filteredStartWeeks, setFilteredStartWeeks] = useState(weeksTable);
  const [filteredEndWeeks, setFilteredEndWeeks] = useState(weeksTable);

  useEffect(() => {
    const startWeek = form.watch("start_week_pickup");
    const endWeek = form.watch("end_week_pickup");

    if (startWeek) {
      setFilteredEndWeeks(weeksTable.filter((week) => week >= startWeek));
    } else {
      setFilteredEndWeeks(weeksTable);
    }

    if (endWeek) {
      setFilteredStartWeeks(weeksTable.filter((week) => week <= endWeek));
    } else {
      setFilteredStartWeeks(weeksTable);
    }
  }, [form.watch("start_week_pickup"), form.watch("end_week_pickup")]);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{title}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={5}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("year_pickup"))}
          name="year_pickup"
          options={yearsTable}
          label="Seleccione un año"
          validation={{ required: "El año es requerido" }}
          disabled={isView}
        />

        <MAutocomplete
          key={JSON.stringify(form.getValues("start_week_pickup"))}
          name="start_week_pickup"
          options={filteredStartWeeks}
          label="Semana inicio recogida"
          validation={{ required: "La semana es requerida" }}
          disabled={isView}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("end_week_pickup"))}
          name="end_week_pickup"
          options={filteredEndWeeks}
          label="Semana final recogida"
          validation={{ required: "La semana es requerida" }}
          disabled={isView}
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default DateRangeWeek;
